import React, { FunctionComponent, } from 'react';
import { Modal, Button } from 'react-bootstrap';

// Components
import Separator from '../Separator/Separator';

// Types and constants
import { ServerError } from '../../shared/types';

export type ErrorDialogProps = {
    openErrorDialog: boolean;
    handleClose: () => void;
    error?: any;
}

const ErrorDialog: FunctionComponent<ErrorDialogProps> = (props: ErrorDialogProps) => {
    const {
        openErrorDialog,
        handleClose,
        error
    } = props;

    const errors: ServerError[] = error.response?.data.errors;

    const errorTitle = error.response.status === 500 ? 'Server error' : 'Validation error';

    return (
        <div role="alert" className='container-fluid page-layout-container'>
            <Modal
                size='xl'
                show={openErrorDialog}
                onHide={handleClose}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{errorTitle}</Modal.Title>
                </Modal.Header>
                <Separator />
                <Modal.Body>
                    <ul>
                        {
                            errors.map((item: ServerError) => {
                                return (
                                    <li key={item.status}>
                                        {
                                            item.source && <><b> {item.source}: </b> <br/> </>
                                        }
                                        {
                                            item.detail && <i>{item.detail}</i>
                                        }
                                    </li>
                                )
                            })
                        }
                    </ul>

                </Modal.Body>
                <Separator />
                <Modal.Footer>
                    <Button
                        variant="outline-dark"
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ErrorDialog;